import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
} from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function DialogDemo() {
  return (
    <Section
      id="dialog"
      title="Dialog"
      description="Modal overlay. Self-contained task — form, preview, confirmation."
    >
      <VariantBlock label="Form dialog">
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline">Edit profile</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Edit profile</DialogTitle>
              <DialogDescription>
                Tweak your display name. Saves on submit.
              </DialogDescription>
            </DialogHeader>
            <div className="grid gap-3">
              <div className="grid gap-1.5">
                <Label htmlFor="name">Display name</Label>
                <Input id="name" defaultValue="Akshit" />
              </div>
              <div className="grid gap-1.5">
                <Label htmlFor="handle">Handle</Label>
                <Input id="handle" defaultValue="@akshit" />
              </div>
            </div>
            <DialogFooter showCloseButton>
              <Button>Save</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </VariantBlock>

      <VariantBlock label="Without close button">
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline">No top-right X</Button>
          </DialogTrigger>
          <DialogContent showCloseButton={false}>
            <DialogHeader>
              <DialogTitle>Manual close only</DialogTitle>
              <DialogDescription>
                Use this pattern when the user must explicitly confirm or
                cancel.
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="outline">Got it</Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </VariantBlock>
    </Section>
  );
}
